//Exécution au chargement de la page
jQuery(document).ready(function ($) {

    var module_name = $("#module_name").val();
    var action_name = $("#action_name").val();
    var base_route = $("#base_route").val();

    //Modalbox de chargement entre chaque étapes
    $(".modal_waiting").click(function () {
        showModalWaiting();
    });

    //Nettoie les champs pré remplis
    $('.clear_input').each(function () {
        var default_value = $(this).val();
        $(this).focus(function () {
            if ($(this).val() == default_value) {
                $(this).val('');
            }
        });
        $(this).blur(function () {
            if ($(this).val() == '') {
                $(this).val(default_value);
            }
        });
    });

    switch (module_name) {
        case 'reservation':
        case 'mon_compte':
        case 'promotions':

            switch (action_name) {
                case 'etapeTrajet':
                case 'etapeTrajetAgences':
                    //Pas de recherche de dispo quand la catégorie n'est pas séléctable
                    $("#propositions_vehicules .proposition:has(.tarif_proposition)").each(function () {
                        var idCategorie = $(this).attr('rel');
                        var testBool = parseInt(idCategorie) || 0;
                        if (testBool) {
                            $.post(base_route + "/_ajax/categories/", {
                                id: idCategorie
                            }, function (data) {
                                if (!data.match(/false/)) {
                                    //Exception IE
                                    if (!$.browser.msie) {
                                        $('.proposition[rel=' + idCategorie + '] table').animate({
                                            opacity: 1
                                        });
                                    } else {
                                        $('.proposition[rel=' + idCategorie + '] table').css({
                                            'opacity': 1
                                        });
                                    }
                                    $('.proposition[rel=' + idCategorie + '] .tarif_proposition').html(data);
                                    $('.proposition[rel=' + idCategorie + '] .selection_proposition').fadeIn();
                                    $('.proposition[rel=' + idCategorie + '] .header_proposition img').hide('Slide');
                                } else {
                                    $('.proposition[rel=' + idCategorie + '] .tarif_proposition').html(data.replace('false', ''));
                                    $('.proposition[rel=' + idCategorie + '] .header_proposition img').hide('Slide');
                                }
                            });
                        }
                    });

                    case 'etapeInfos':
                        jQuery('li[id^="info_agence_depart"]').click(function () {
                            var idAgenceDepart = $(this).attr('id').replace(/\D+/, '');
                            emptyProducts(idAgenceDepart, 'depart');
                            /*if($('#form-agence-depart-retour-linking').length && $('#form-agence-depart-retour-linking').attr('data-value') == 'undefined') {
                             $('.input-arrival span.agency-value').text($(this).find('span.name').text());
                             } */
                        });

                        jQuery('li[id^="info_agence_retour"]').click(function () {
                            var idAgenceRetour = $(this).attr('id').replace(/\D+/, '');
                            emptyProducts(idAgenceRetour, 'retour');
                            //refreshDates('agence_retour', true);
                            //$('#form-agence-depart-retour-linking').attr('data-value', '1');
                        });

                        //break;

                    case 'fiche':
                        //Mise à jour dès chargement de la page
                        //refreshDates('agence_depart', false);

                        //Pas d'aller retour pour l'instant
                        disableOrNotSelectCategoriesVehicule();


                        //jQuery('#as_id_agence_depart_selector ul li a').live('click', function(){
                        //refreshDates('agence_depart', true)
                        //} );


                        jQuery('#id_agence_depart').change(function () {
                            var value = $(this).val();
                            var idAgenceDepart = value.replace(/\D+/, '');
                            emptyProducts(idAgenceDepart, 'depart');
                        });

                        //jQuery('#id_agence_retour').change( function(){
                        //emptyProducts();
                        //refreshDates('agence_retour', true);
                        //} );
                        //jQuery('#date_depart').change( function(){
                        //refreshDates('date_depart', true);
                        //} );
                        //jQuery('#date_retour').change( function(){
                        //refreshDates('date_retour', true);
                        //} );

                        //jQuery('#heure_depart').change(function () {
                        //refreshHours('heure_depart');
                        //});
                        //jQuery('#heure_retour').change(function () {
                        //refreshHours('heure_retour');
                        //});


                        jQuery('#type_categorie_vehicules').change(function () {
                            var typeCategorieVehicules = $('#type_categorie_vehicules');
                            if (typeCategorieVehicules.val() != '') {
                                var idType = typeCategorieVehicules.val();
                                $('#ligne_categorie_vehicules img').show();
                                $('#id_categorie_vehicules').attr('disabled', true);
                                $.post(base_route + "/_ajax/types/", {
                                    id: idType
                                    }, function (data) {
                                        $('#ligne_categorie_vehicules').html(data);
                                    });
                            } else {
                                disableOrNotSelectCategoriesVehicule();
                            }
                        });

                        $('#is_retour_egal').click(function () {
                            $('#id_agence_retour').parent().slideToggle()
                        });

                        if (!$('#is_retour_egal').is(':checked')) {
                            $('#id_agence_retour').parent().show()
                        }

                        //Impossible de changer la date directement dans le champ
                        $("#date_depart").attr('readonly', true);
                        $("#date_retour").attr('readonly', true);



                        setTimeout(function () {
                            if ($('#mock-date').length) {
                                $('#date_depart').datepicker().datepicker('setDate', $('#mock-date').text());
                                $('#date_depart').datepicker().datepicker('option', 'minDate', $('#mock-date').text());
                            }
                        }, 1500);

                    break;

                case 'etapeDevisServices':
                    //Ajout ou suppression d'un produit
                    $("#tableau_produits .champ input").click(function () {
                        var idProduit = $(this).parent().attr('rel');
                        var isChecked = !$(this).is(':checked');
                        $.post(base_route + "/_ajax/option/", {
                            id_produit: idProduit,
                            checked: isChecked
                        }, function (data) {
                            if (isChecked) {
                                $(".check[rel=" + idProduit + "]").parent('.champ').removeClass('product-selected');
                            } else {
                                $(".check[rel=" + idProduit + "]").parent('.champ').addClass('product-selected');
                            }
                            $('#recapitulatif_produits span').html(data);
                            $.post(base_route + "/_ajax/reloadSidebar/", {}, function (data) {
                                $('#sidebar').html(data);
                                hideModalWaiting();
                                if (typeof initSidebar == 'function') {
                                    initSidebar();
                                }
                            }).fail(function () {
                                showLoader();
                                window.location.reload();
                            });
                        });
                    });

                    //Ajout ou suppression d'un produit avec quantité
                    $("#tableau_produits .champ select").change(function () {
                        var idProduit = $(this).parent().attr('rel');
                        var quantiteProduit = $(this).val();
                        showModalWaiting();
                        //Si la quantité du produit est égal à 0, on le supprime
                        if (quantiteProduit == 0) {
                            $.post(base_route + "/_ajax/option/", {
                                id_produit: idProduit,
                                checked: 'true'
                            }, function (data) {
                                $(".check[rel=" + idProduit + "]").parent('.champ').removeClass('product-selected');
                                $('#recapitulatif_produits span').html(data);
                                $.post(base_route + "/_ajax/reloadSidebar/", {}, function (data) {
                                    $('#sidebar').html(data);
                                }).fail(function () {
                                    showLoader();
                                    window.location.reload();
                                });
                                hideModalWaiting();
                                if (typeof initSidebar == 'function') {
                                    initSidebar();
                                }
                            });
                        } else {
                            $.post(base_route + "/_ajax/option/", {
                                id_produit: idProduit,
                                quantite: quantiteProduit
                            }, function (data) {
                                $(".check[rel=" + idProduit + "]").parent('.champ').addClass('product-selected');
                                $('#recapitulatif_produits span').html(data);
                                $.post(base_route + "/_ajax/reloadSidebar/", {}, function (data) {
                                    $('#sidebar').html(data);
                                }).fail(function () {
                                    showLoader();
                                    window.location.reload();
                                });
                                hideModalWaiting();
                                if (typeof initSidebar == 'function') {
                                    initSidebar();
                                }
                            });
                        }
                    });

                    break;

                    //Mon compte
                case 'donneesPersonnelles':
                    //Accordeon dans l'espace mon compte
                    $('.form_zone h3').click(function () {
                        var rel = $(this).attr('rel');
                        var h3_tab = $('h3[rel=' + rel + ']');
                        if (h3_tab.hasClass('hide')) {
                            $('.form_zone:has(h3.unlocked) > ul:not(#' + rel + ')').slideUp();
                            $('h3.unlocked a').html('Voir le détail');
                            $('h3.unlocked').removeClass('unlocked').addClass('hide');

                            h3_tab.removeClass('hide');
                            $('.form_zone > ul#' + rel).slideDown();
                            $('h3[rel=' + rel + '] a').html('Laisser ouvert');
                            h3_tab.addClass('unlocked');
                        } else if (h3_tab.hasClass('unlocked')) {
                            h3_tab.removeClass('unlocked');
                            $('h3[rel=' + rel + '] a').html('Fermer');
                            h3_tab.addClass('locked');
                        } else if (h3_tab.hasClass('locked')) {
                            h3_tab.removeClass('locked');
                            $('.form_zone > ul#' + rel).slideUp();
                            $('h3[rel=' + rel + '] a').html('Voir le détail');
                            h3_tab.addClass('hide');
                        }
                        return false;
                    });

                    //Autocomplete des villes en fonction du code postal
                    $('#code_postal').autocomplete({
                        source: base_route + "/_ajax/codepostalVille/",
                        minLength: 5,
                        select: function (event, ui) {
                            $('#ville').val(ui.item.label);
                        }
                    });

                    //Autocomplete des pays
                    $('#pays').autocomplete({
                        source: base_route + "/_ajax/pays/",
                        minLength: 2,
                        select: function (event, ui) {
                            $('#pays').val(ui.item.label);
                        }
                    });

                    //Affichage ou non de la partie entreprise du formulaire
                    //On masque par défaut les champs
                    var inputIsSocieteParticulier = $('#is_societe_particulier');
                    var inputIsSocietePro = $('#is_societe_professionnel');
                    if (!inputIsSocietePro.is(':checked')) {
                        $('#raison_sociale').parent().hide();
                        $('#statut_societe').parent().hide();
                    }
                    inputIsSocieteParticulier.click(function () {

                        $('#raison_sociale').parent().slideUp();
                        $('#statut_societe').parent().slideUp();

                    });
                    inputIsSocietePro.click(function () {

                        $('#raison_sociale').parent().slideDown();
                        $('#statut_societe').parent().slideDown();

                    });

                    case 'etapeDonneesPersonnelles':


                        //Lost Password
                        $('#btn_lost_password').click(function () {
                            $('#lost_password').slideToggle();
                            return false;
                        });

                        //Recherche de dispo email lors de la perte du focus sur le champ
                        $('#reservation_tiers_form #tiers_email').keyup(function () {
                            var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

                            if ($(this).hasClass('check_email_sit')) {
                                var champ = $(this);
                                var email = jQuery.trim(champ.val());
                                if (email != '' && emailReg.test(email)) {
                                    $.post(base_route + "/_ajax/disponibiliteEmail/", {
                                        email: email
                                    }, function (data) {
                                        if (data === 'false') {
                                            champ.next().html('<ul class="error_list" id="email_error" style="display: none;"><li>Cette adresse e-mail est déjà associée à un compte client.<br/>Veuillez vous connecter dans l’espace prévu à cet effet 2.</li></ul>').fadeIn();
                                            $('#email_error').fadeIn();
                                        }
                                        if (data === 'true') {
                                            $('#email_error').fadeOut();
                                        }
                                    });
                                }
                            }
                        });

                        //Tooltip pour les emails Gmail et Yahoo
                        /* if ($('#reservation_tiers_form #tiers_email').length) {
                         var info_mail = $('#info_mail').html();
                         var tooltip = $('#reservation_tiers_form #tiers_email').qtip({
                         content: info_mail,
                         style: {
                         name: 'blue',
                         tip: 'bottomMiddle',
                         width: {
                         max: 420
                         }
                         },
                         position: {
                         corner: {
                         target: 'topMiddle',
                         tooltip: 'bottomMiddle'
                         }
                         },
                         show: false,
                         hide : {
                         delay: 10000
                         }
                         });
                         }*/

                        /* $('#reservation_tiers_form #tiers_email').bind('keyup', function () {
                         var email = $('#reservation_tiers_form #tiers_email').val();
                         if (email.match('@yahoo.') || email.match('@gmail.')) {
                         jQuery(tooltip).qtip('show');
                         } else {
                         jQuery(tooltip).qtip('hide');
                         }
                         });*/

                        //Tooltip pour les emails Gmail et Yahoo pour le recouvrement de mot de passe
    //                    if ($('#lost_password #email').length) {
    //                        $('#lost_password #email').qtip({
    //                            content: info_mail,
    //                            style: {
    //                                name: 'blue',
    //                                tip: 'bottomMiddle',
    //                                width: {
    //                                    max: 420
    //                                }
    //                            },
    //                            position: {
    //                                corner: {
    //                                    target: 'topMiddle',
    //                                    tooltip: 'bottomMiddle'
    //                                }
    //                            },
    //                            show: false,
    //                            hide: {
    //                                delay: 10000
    //                            }
    //                        });
    //                    }

    //                    $('#lost_password #email').bind('keyup', function () {
    //                        var email = $('#lost_password #email').val();
    //                        if (email.match('@yahoo.') || email.match('@gmail.')) {
    //                            jQuery(tooltip).qtip('show');
    //                        } else {
    //                            jQuery(tooltip).qtip('hide');
    //                        }
    //                    });


                        //Autocomplete des villes en fonction du code postal
                        $('#tiers_code_postal').autocomplete({
                            source: base_route + "/_ajax/codepostalVille/",
                            minLength: 5,
                            select: function (event, ui) {
                                $('#tiers_ville').val(ui.item.label);
                            }
                        });

                        //Autocomplete du pays
                        $('#tiers_pays').autocomplete({
                            source: base_route + "/_ajax/pays/",
                            minLength: 2,
                            select: function (event, ui) {
                                $('#tiers_pays').val(ui.item.label);
                            }
                        });

                        //Affichage ou non de la partie entreprise du formulaire
                        //On masque par défaut les champs
                        var inputIsSocieteParticulier = $('#tiers_is_societe_particulier');
                        var inputIsSocietePro = $('#tiers_is_societe_professionnel');
                        if (!inputIsSocietePro.is(':checked')) {
                            $('#tiers_raison_sociale').parent().hide();
                            $('#tiers_statut_societe').parent().hide();
                        }
                        inputIsSocieteParticulier.click(function () {
                            /*if ($.browser.msie) {
                             $('#tiers_raison_sociale').parent().hide();
                             $('#tiers_statut_societe').parent().hide();
                             } else {*/
                            $('#tiers_raison_sociale').parent().slideUp();
                            $('#tiers_statut_societe').parent().slideUp();
                            //}
                        });
                        inputIsSocietePro.click(function () {
                            /*if ($.browser.msie) {
                             $('#tiers_raison_sociale').parent().show();
                             $('#tiers_statut_societe').parent().show();
                             } else {*/
                            $('#tiers_raison_sociale').parent().slideDown();
                            $('#tiers_statut_societe').parent().slideDown();
                            //}
                        });

                        $('.input_disabled').attr('readonly', true).addClass('disabled_by_jquery');
                    break;

//        case 'etapePaiementExterneDG':
//        case 'etapePaiementExterne':
//        case 'etapePaiementMoyenneDuree':
//        case 'etapePaiement':
//          $('body:not(.paiement-v3) #form_reservation_paiement').submit(function () {
//            //On attribue le moyen de paiement au bouton submit
//
//            /*if ($('.card .option').hasClass('current')) {
//             return true;
//             }
//             else {
//             $('section#loader').fadeOut();
//
//             showModalSimple();
//             return false;
//             } */
//            if ($('#moyen_paiement_CB').is(':checked')) {
//              $('#img_paiement').attr('name', 'CB');
//              showModalWaiting();
//              return true;
//            }
//            if ($('#moyen_paiement_MASTERCARD').is(':checked')) {
//              $('#img_paiement').attr('name', 'MASTERCARD');
//              showModalWaiting();
//              return true;
//            }
//            if ($('#moyen_paiement_VISA').is(':checked')) {
//              $('#img_paiement').attr('name', 'VISA');
//              showModalWaiting();
//              return true;
//            }
//            showModalSimple();
//            return false;
//          });
//          break;

                    //Espace Mon Compte
                case 'modifierPass':
                    //Tooltip pour date de permis
//                    if ($('.infos').length) {
//                        var info = $('#info_modifier_pass').html();
//                        $('.infos').qtip({
//                            content: info,
//                            style: {
//                                name: 'blue',
//                                tip: 'bottomRight'
//                            },
//                            position: {
//                                corner: {
//                                    target: 'topLeft',
//                                    tooltip: 'bottomRight'
//                                }
//                            }
//                        });
//                    }
                    break;
            }
            break;
    }




});

jQuery(window).on('load', function () {
    setTimeout(function () {
        //Modalbox de présentation des messages
        var dialogModal = $("#dialog-modal");
        if (dialogModal.is('div')) {
            showModal();
        }
    }, 1200);
});

function emptyProducts(idAgence, typeId)
{
    var base_route = $("#base_route").val();
    $.post(base_route + "/_ajax/emptyProducts/", {
        id_agence: idAgence,
        id_type: typeId
    }, function (data) {
    });
}

function obsolete_refreshHours(champ)
{
    var base_route = $("#base_route").val();
    $.ajax({
        url: base_route + "/_date/refreshHours/field/" + champ,
        dataType: "script",
        data: '',
        success: function (data) {
        }
    });
}


function obsolete_refreshDates(champ, widgetTriggered)
{
    var base_route = $("#base_route").val();
    var data_form = $('#reservation_form').serialize();
    var form_serialized = data_form + '&champ=' + champ + '&form=reservation';
    //On grise les champs + affichage du logo chargement
    /*if (!$.browser.msie) {
     $('#reservation_form #heure_depart, #reservation_form #heure_retour').animate({
     opacity: 0.3
     });
     } */
    $('#ligne_depart img').show();
    $('#ligne_retour img').show();
    $.ajax({
        url: base_route + "/_date/refreshDates" + (widgetTriggered == true ? '/triggered/1' : ''),
        dataType: "script",
        data: form_serialized,
        success: function (data) {
            $('#ligne_depart img').hide();
            $('#ligne_retour img').hide();

//      if (!$.browser.msie) {
            $('#reservation_form #heure_depart, #reservation_form #heure_retour').animate({
                opacity: 1
            });
            //    }
        }

    });
}

function showModalWaiting()
{
    $("body").css("overflow", "hidden");
    $("#dialog-modal-submit").dialog({
        height: 110,
        width: 380,
        modal: true,
        resizable: false
    });
    $(".ui-dialog-titlebar").hide();
    $(".ui-dialog-titlebar-close").hide();
    var opts = {
        lines: 12, // The number of lines to draw
        length: 7, // The length of each line
        width: 4, // The line thickness
        radius: 12, // The radius of the inner circle
        color: '#333', // #rbg or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false // Whether to render a shadow
    };
    $("#spin_loader").spin(opts);
}

function showModal()
{
    $("body").css("overflow", "hidden");
    $("#dialog-modal").dialog({
        height: "auto",
        width: 400,
        modal: true,
        resizable: false,
        closeOnEscape: true,
        close: function () {
            $("body").css("overflow", "auto");
        }
    });
}

function showModalSimple()
{
    $("body").css("overflow", "hidden");

    $("#dialog-modal-simple").dialog({
        height: "auto",
        width: 400,
        modal: true,
        resizable: false,
        closeOnEscape: true,
        close: function () {
            $("body").css("overflow", "auto");
        }
    });
}
function showModalMonCompte(param)
{
    $("body").css("overflow", "hidden");
    $("#dialog-modal-moncompte" + param).dialog({
        height: "auto",
        width: 600,
        modal: true,
        resizable: false,
        closeOnEscape: true,
        close: function () {
            $("body").css("overflow", "auto");
        }
    });
}

function hideModalWaiting()
{
    if ($("#dialog-modal-submit").dialog("instance") !== undefined) {
        $("#dialog-modal-submit").dialog('close');
    }
    $("body").css("overflow", "auto");
}

function disableOrNotSelectCategoriesVehicule()
{
    if ($('#type_categorie_vehicules').val() == '') {
        $('#id_categorie_vehicules').attr('disabled', true)
    } else {
        $('#id_categorie_vehicules').attr('disabled', false)
    }
}

//Plugin Spin
$.fn.spin = function (opts) {
    this.each(function () {
        var spinner = $(this).data('spinner');
        if (spinner) {
            spinner.stop();
        }
        if (opts !== false) {
            $(this).data('spinner', new Spinner(opts).spin(this));
        }
    });
    return this;
}

function html_entity_decode(string, quoteStyle)
{
    // http://kevin.vanzonneveld.net
    // +   original by: john (http://www.jd-tech.net)
    // +      input by: ger
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   bugfixed by: Onno Marsman
    // +   improved by: marc andreu
    // +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +      input by: Ratheous
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Nick Kolosov (http://sammy.ru)
    // +   bugfixed by: Fox
    // -    depends on: get_html_translation_table
    // *     example 1: html_entity_decode('Kevin &amp; van Zonneveld');
    // *     returns 1: 'Kevin & van Zonneveld'
    // *     example 2: html_entity_decode('&amp;lt;');
    // *     returns 2: '&lt;'
    var hashMap = {},
        symbol = '',
        tmpStr = '',
        entity = '';
    tmpStr = string.toString();

    if (false === (hashMap = this.get_html_translation_table('HTML_ENTITIES', quoteStyle))) {
        return string;
    }

    // fix &amp; problem
    // http://phpjs.org/functions/get_html_translation_table:416#comment_97660
    delete(hashMap['&']);
    hashMap['&'] = '&amp;';

    for (symbol in hashMap) {
        entity = hashMap[symbol];
        tmpStr = tmpStr.split(entity).join(symbol);
    }
    tmpStr = tmpStr.split('&#039;').join("'");

    return tmpStr;
}

function get_html_translation_table(table, quoteStyle)
{
    // http://kevin.vanzonneveld.net
    // +   original by: Philip Peterson
    // +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   bugfixed by: noname
    // +   bugfixed by: Alex
    // +   bugfixed by: Marco
    // +   bugfixed by: madipta
    // +   improved by: KELAN
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Frank Forte
    // +   bugfixed by: T.Wild
    // +      input by: Ratheous
    // %          note: It has been decided that we're not going to add global
    // %          note: dependencies to php.js, meaning the constants are not
    // %          note: real constants, but strings instead. Integers are also supported if someone
    // %          note: chooses to create the constants themselves.
    // *     example 1: get_html_translation_table('HTML_SPECIALCHARS');
    // *     returns 1: {'"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;'}
    var entities = {},
        hashMap = {},
        decimal;
    var constMappingTable = {},
        constMappingQuoteStyle = {};
    var useTable = {},
        useQuoteStyle = {};

    // Translate arguments
    constMappingTable[0] = 'HTML_SPECIALCHARS';
    constMappingTable[1] = 'HTML_ENTITIES';
    constMappingQuoteStyle[0] = 'ENT_NOQUOTES';
    constMappingQuoteStyle[2] = 'ENT_COMPAT';
    constMappingQuoteStyle[3] = 'ENT_QUOTES';

    var useTableElse = table ? table.toUpperCase() : 'HTML_SPECIALCHARS';
    var useQuoteStyleElse = quoteStyle ? quoteStyle.toUpperCase() : 'ENT_COMPAT';

    useTable = !isNaN(table) ? constMappingTable[table] : useTableElse;
    useQuoteStyle = !isNaN(quoteStyle) ? constMappingQuoteStyle[quoteStyle] : useQuoteStyleElse;

    if (useTable !== 'HTML_SPECIALCHARS' && useTable !== 'HTML_ENTITIES') {
        throw new Error("Table: " + useTable + ' not supported');
        // return false;
    }

    entities['38'] = '&amp;';
    if (useTable === 'HTML_ENTITIES') {
        entities['160'] = '&nbsp;';
        entities['161'] = '&iexcl;';
        entities['162'] = '&cent;';
        entities['163'] = '&pound;';
        entities['164'] = '&curren;';
        entities['165'] = '&yen;';
        entities['166'] = '&brvbar;';
        entities['167'] = '&sect;';
        entities['168'] = '&uml;';
        entities['169'] = '&copy;';
        entities['170'] = '&ordf;';
        entities['171'] = '&laquo;';
        entities['172'] = '&not;';
        entities['173'] = '&shy;';
        entities['174'] = '&reg;';
        entities['175'] = '&macr;';
        entities['176'] = '&deg;';
        entities['177'] = '&plusmn;';
        entities['178'] = '&sup2;';
        entities['179'] = '&sup3;';
        entities['180'] = '&acute;';
        entities['181'] = '&micro;';
        entities['182'] = '&para;';
        entities['183'] = '&middot;';
        entities['184'] = '&cedil;';
        entities['185'] = '&sup1;';
        entities['186'] = '&ordm;';
        entities['187'] = '&raquo;';
        entities['188'] = '&frac14;';
        entities['189'] = '&frac12;';
        entities['190'] = '&frac34;';
        entities['191'] = '&iquest;';
        entities['192'] = '&Agrave;';
        entities['193'] = '&Aacute;';
        entities['194'] = '&Acirc;';
        entities['195'] = '&Atilde;';
        entities['196'] = '&Auml;';
        entities['197'] = '&Aring;';
        entities['198'] = '&AElig;';
        entities['199'] = '&Ccedil;';
        entities['200'] = '&Egrave;';
        entities['201'] = '&Eacute;';
        entities['202'] = '&Ecirc;';
        entities['203'] = '&Euml;';
        entities['204'] = '&Igrave;';
        entities['205'] = '&Iacute;';
        entities['206'] = '&Icirc;';
        entities['207'] = '&Iuml;';
        entities['208'] = '&ETH;';
        entities['209'] = '&Ntilde;';
        entities['210'] = '&Ograve;';
        entities['211'] = '&Oacute;';
        entities['212'] = '&Ocirc;';
        entities['213'] = '&Otilde;';
        entities['214'] = '&Ouml;';
        entities['215'] = '&times;';
        entities['216'] = '&Oslash;';
        entities['217'] = '&Ugrave;';
        entities['218'] = '&Uacute;';
        entities['219'] = '&Ucirc;';
        entities['220'] = '&Uuml;';
        entities['221'] = '&Yacute;';
        entities['222'] = '&THORN;';
        entities['223'] = '&szlig;';
        entities['224'] = '&agrave;';
        entities['225'] = '&aacute;';
        entities['226'] = '&acirc;';
        entities['227'] = '&atilde;';
        entities['228'] = '&auml;';
        entities['229'] = '&aring;';
        entities['230'] = '&aelig;';
        entities['231'] = '&ccedil;';
        entities['232'] = '&egrave;';
        entities['233'] = '&eacute;';
        entities['234'] = '&ecirc;';
        entities['235'] = '&euml;';
        entities['236'] = '&igrave;';
        entities['237'] = '&iacute;';
        entities['238'] = '&icirc;';
        entities['239'] = '&iuml;';
        entities['240'] = '&eth;';
        entities['241'] = '&ntilde;';
        entities['242'] = '&ograve;';
        entities['243'] = '&oacute;';
        entities['244'] = '&ocirc;';
        entities['245'] = '&otilde;';
        entities['246'] = '&ouml;';
        entities['247'] = '&divide;';
        entities['248'] = '&oslash;';
        entities['249'] = '&ugrave;';
        entities['250'] = '&uacute;';
        entities['251'] = '&ucirc;';
        entities['252'] = '&uuml;';
        entities['253'] = '&yacute;';
        entities['254'] = '&thorn;';
        entities['255'] = '&yuml;';
    }

    if (useQuoteStyle !== 'ENT_NOQUOTES') {
        entities['34'] = '&quot;';
    }
    if (useQuoteStyle === 'ENT_QUOTES') {
        entities['39'] = '&#39;';
    }
    entities['60'] = '&lt;';
    entities['62'] = '&gt;';


    // ascii decimals to real symbols
    for (decimal in entities) {
        if (entities.hasOwnProperty(decimal)) {
            hashMap[String.fromCharCode(decimal)] = entities[decimal];
        }
    }

    return hashMap;
}
